<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-10">
			<!-- Empty car-->
				<section class="account-section">
					<h2>Compras anteriores</h2>
					<table class="table" v-if="render_orders.length">
						<thead>
							<tr>
								<th>Id</th>
								<th>Fecha</th>
								<th>No. de Pedido</th>
								<th>Archivo</th>
								<th>Total</th>
								<th>Factura</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="order in render_orders">
								<td>{{ $index + 1 }}</td>
								<td>{{ moment(order.created_at).format('YYYY-MM-DD') }}</td>
								<td>{{ order.payment_id }}</td>
								<td><a href="{{ link }}/users/me/purchaseOrders/{{ order.payment_id }}/pdf?api_token={{ render_user.token }}" target="_blank">Descargar</a></td>
								<td>${{ accounting.formatMoney(parseFloat(order.total).toFixed(2), '') }}</td>
								<td v-if="order.invoice_able">
									<a class="btn btn-black btn-sm" @click="requestInvoice(order)">Solicitar</a>
								</td>
								<td v-if="!order.invoice_able">-</td>
							</tr>
						</tbody>
					</table>
				</section>
				<div v-if="!render_orders.length" class="empty padding-left">No tienes compras anteriores.</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.padding-left {
		padding-left: 25px;
	}
</style>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import moment from 'moment/min/moment.min.js';
import { router } from '../../routes/routes';
import { api_base } from '../../store/api';
import accounting from '../../scripts/accounting';

export default {
	data() {
		return {
			link: api_base,
			accounting
		}
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			billing_info: state => state.billing_info,
			user: state => state.current_user,
			orders: state => {
				let orders = state.purchase_orders;
				let purchase_orders = [];

				for (let i = 0, o = orders; i < o.length; i++) {
					if (o[i].status_string.toLowerCase() == 'pagado')
						purchase_orders.push(o[i]);
				}

				return purchase_orders;
			}
		}
	},

	// ---- RENDER ----

	computed: {
		render_orders() {
			return this.orders;
		},

		render_user() {
			return this.user;
		}
	},

	methods: {
		moment,

		requestInvoice (order) {
			router.go(`/solicitar-factura/${ order.payment_id }`);
		}
	},

	// ---- COMPONENTS ----

  components: {
  	Breadcrumb,
  	Sidebar
  }
};
</script>


// WEBPACK FOOTER //
// Previous-purchases.vue?66378a41